import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";
import SpecInformationLead from "./specInformationLead";

/* This class represents a lead of type More Information for a basic spec. */
export default class SpecInformationLeadBasic extends SpecInformationLead {
    constructor(formData) {
      super(formData);
      this.type = 'postSpecBrochureBasic';
      this.xxTrustedFormCertUrl = formData.xxTrustedFormCertUrl;
      this.guid = formData.guid;
    }

    static getLeadSubmitedAnalyticsData() {
      return new GoogleAnalyticsEvent("TDV Events", "Direct Leads", "Search-CTA-Learn-More")
    }
  }